import { useState, useEffect } from 'react';
import DetailsTable from './DetailsTable';
import DetailsForm from './DetailsForm/DetailsForm';
import { useDispatch, useSelector } from 'react-redux';
import {
    oneClient,
    clientTermsAndPrivacy,
    clientDataStore,
    getClientDataStore,
} from '../../../../redux/slices/clientsSlice';
import { Button } from 'antd';
import { Edit } from '../../../../components/Svg/Svg';
import { Helmet } from 'react-helmet';
import { countriesOptions } from '../../../../shared/data/clientDetailsOptions';

export default function ClientDetailsSubPage() {
    const dispatch = useDispatch();
    const client = useSelector(oneClient);
    const termsAndPrivacy = useSelector(clientTermsAndPrivacy);
    const generalData = useSelector(clientDataStore);

    const countriesLocalizationsData = client?.countries_localizations?.reduce(
        (acc, el) => {
            acc[el.country_code] = el;
            return acc;
        },
        {},
    );

    const [view, setView] = useState('view');
    const [excludedCodes, setExcludedCodes] = useState([]);

    useEffect(() => {
        if (!!Object.keys(generalData).length) {
            const excludedCodes = countriesOptions
                .filter(
                    (option) =>
                        !generalData?.account_countries?.includes(option.id),
                )
                .map((item) => item.id.toLowerCase());

            setExcludedCodes(excludedCodes);
        }
    }, [generalData]);
    
    const onEditClick = () => {
        setView('edit');
    };

    const onCancelButtonClick = () => {
        setView('view');

        dispatch(
            getClientDataStore({
                id: client.client_uid,
                collectionName: 'clients',
            }),
        );
    };

    return (
        <div>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - Details`}</title>
            </Helmet>
            <div className="details-table-wrapper">
                <div className="table-top-pannel">
                    <div className="table-top-pannel__info">
                        <h2 className="table-top-pannel__title">
                            General details
                        </h2>
                    </div>
                    {view === 'view' && (
                        <Button
                            type="primary"
                            size="large"
                            onClick={onEditClick}
                        >
                            <Edit />
                            <span style={{ marginLeft: '8px' }}>Edit info</span>
                        </Button>
                    )}
                    {view === 'edit' && (
                        <div className="details-table__buttons-wrapper">
                            <button
                                className="details-table__button modal__button-cancel"
                                onClick={onCancelButtonClick}
                            >
                                Cancel
                            </button>
                            <button
                                className="details-table__button modal__button-accept"
                                type="submit"
                                form="edit-client-form"
                            >
                                Save
                            </button>
                        </div>
                    )}
                </div>
                {view === 'view' && (
                    <DetailsTable
                        client={client}
                        countries={countriesLocalizationsData}
                        generalData={generalData}
                        excludedCodes={excludedCodes}
                    />
                )}
                {view === 'edit' && (
                    <DetailsForm
                        client={client}
                        generalData={generalData}
                        termsAndPrivacy={termsAndPrivacy}
                        setView={setView}
                        excludedCodes={excludedCodes}
                    />
                )}
            </div>
        </div>
    );
}
